import { graphql } from 'gatsby';

import { MediaGallery, VideoData } from '@mewa/ui';

import {
  ConfigType,
  ContentSectionItem,
  PossibleContentSections,
} from '../fragment-and-types';
import { ContentLivePreviewConfig } from '../live-preview/types';
import { StrapiImage, StrapiImageData } from './image';

export type MediaGalleryData = {
  mediaItem: {
    media: { mime: string } & StrapiImageData;
    description: string;
  }[];
  strapi_component: typeof componentName;
};

export type MediaGalleryPreviewData = MediaGalleryData;

export const query = graphql`
  fragment MediaGalleryFragment on STRAPI__COMPONENT_SHARED_MEDIA_GALLERY {
    mediaItem {
      description
      media {
        fields {
          assetUrl
        }
        width
        height
        mime
      }
    }
    strapi_component
  }
`;

const componentName = 'shared.media-gallery';

const isComponent = (
  section: PossibleContentSections,
): section is ContentSectionItem<MediaGalleryData> =>
  section.strapi_component === componentName;

const Component = (props: MediaGalleryData) => {
  const items = props.mediaItem.flatMap((mediaItem) => ({
    media: mediaItem.media.mime.startsWith('image') ? (
      <StrapiImage image={mediaItem.media} />
    ) : (
      ({
        desktopSources: [
          { src: mediaItem.media.fields.assetUrl, type: mediaItem.media.mime },
        ],
      } as VideoData)
    ),
    description: mediaItem.description,
  }));

  return <MediaGallery items={items} />;
};

export const config: ConfigType<MediaGalleryData> = {
  Component,
  isComponent,
  componentName,
};

export const previewConfig: ContentLivePreviewConfig = {
  componentName,
  populationParams: {
    mediaItem: {
      populate: {
        media: '*',
      },
    },
  },
  mapProperties: (data) =>
    data.strapi_component === componentName ? data : null,
};
